module.exports = __webpack_public_path__ + "static/fonts/SourceHanSansCN-Bold.b3be1a9.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/SourceHanSansCN-Bold.otf
// module id = lZDY
// module chunks = 1